<template>
    <div class="chatRecord">
      <el-tabs style="padding: 0 0.2rem 0 0.4rem" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="沟通记录" name="first">
          <div class="m-tabs-content" style="height: auto;">
            <el-row>
              <el-col :span=24>
                <div class="block">
                  <el-timeline>
                    <el-timeline-item
                      class="time_class"
                      v-if="activities.length"
                      v-for="(activity, index) in activities"
                      :key="index"
                      :icon="activity.icon"
                      :type="activity.type"
                      :color="activity.color"
                      :size="activity.size">
                      <span style="color: #666666;  display: inline-block; margin-bottom: .2rem">{{activity.uname+ '于' }}</span>
                      <span style="color: #666666;">{{activity.created_time}}</span>
                      <span style="color: #666666;">{{activity.communicat_type}}</span>
                      <div class="time_right time_line">
                        <span>{{activity.communication_note}}</span>
                      </div>
                      <div class="time_right">
                        <el-link
                          class="handleLinkImg"
                          v-for="(items, indexs) in activity.preview"
                          :key="indexs"
                          @click="handleLinkImg(indexs, index)"
                          type="primary">
                          {{'图片' + (indexs + 1)}}
                        </el-link>
                      </div>
                      <div class="m_comment public"
                           v-if="activity.son"
                           v-for="(item, id) in activity.son"
                           :key="id">
                        <div class="comment_name_time">
                          <span style="color: rgb(102, 102, 102)" class="comment_name">{{item.username}}</span>
                          <span style="color: rgb(102, 102, 102)" class="comment_time">{{item.created_at}}</span>
                        </div>
                        <div class="comment_content">
                          <span class="cot">{{item.communicat_content}}</span>
                        </div>
                      </div>
                      <div class="comment_textarea"
                           v-if="commentVisible  === index"
                           style="margin-bottom: .2rem;margin-top: .2rem">
                        <el-input
                          type="textarea"
                          placeholder="请输入要回复的信息"
                          :autosize="textareaSize"
                          style="font-size: .28rem"
                          v-model="addCommentData.communicat_content"/>
                      </div>
                      <div style="width: 100%;text-align: right;">
                        <el-button size="mini" type="primary" v-if="buttonVisible !==  index" @click="handleComment(activity, index)">回复</el-button>
                        <el-button size="mini" type="primary" v-if="buttonVisible === index" @click="handleCommentConfirm(activity, index)">保存</el-button>
                      </div>

                    </el-timeline-item>
                    <div v-if="!activities.length">没有记录</div>
                  </el-timeline>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>

        <el-tab-pane label="线索历史" name="second">
          <div class="blocka">
            <el-timeline>
              <el-timeline-item  v-for="(OperationRecord, index)  in OperationRecord" :key="index" :timestamp="OperationRecord.created_at" placement="top">
                <el-card>
                  <p>{{OperationRecord.operate}}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-tab-pane>

        <el-tab-pane label="基础信息" name="third">
            <el-row class="m-tab">
              <el-col :span="5" class="m-th">
                <el-tooltip content="客户状态" placement="top"><span class="count-style">客户状态</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.status" placement="top">
                    <span class="count-style">{{ singleThread.status }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="客户姓名" placement="top"><span class="count-style">客户姓名</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.custom_name" placement="top">
                    <span class="count-style">{{ singleThread.custom_name }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="客户性格" placement="top"><span class="count-style">客户性格</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.custom_trait" placement="top">
                    <span class="count-style">{{ singleThread.custom_trait }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="客户性别" placement="top"><span class="count-style">客户性别</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.custom_sex" placement="top">
                    <span class="count-style">{{ singleThread.custom_sex }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="客户类型" placement="top"><span class="count-style">客户类型</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.custom_type" placement="top">
                    <span class="count-style">{{ singleThread.custom_type }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="主营行业" placement="top"><span class="count-style">主营行业</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.custom_industry" placement="top">
                    <span class="count-style">{{ singleThread.custom_industry }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="所属省市" placement="top"><span class="count-style">所属省市</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.custom_city_name" placement="top">
                    <span class="count-style">{{ singleThread.custom_city_name }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="客户手机号" placement="top"><span class="count-style">客户手机号</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <!-- <el-tooltip :content="singleThread.custom_phone" placement="top"> -->
                    <span class="count-style">{{ maskedPhoneNumber(singleThread.custom_phone) }}</span>
                <!-- </el-tooltip> -->
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="手机号省市" placement="top"><span class="count-style">手机号省市</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.custom_phone" placement="top">
                    <span class="count-style">{{ singleThread.phone_province ? singleThread.phone_province : '暂无' }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="微信号" placement="top"><span class="count-style">微信号</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.wechat_account" placement="top">
                    <span class="count-style">{{ singleThread.wechat_account }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="是否特殊行业" placement="top"><span class="count-style">是否特殊行业</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.is_special_industry" placement="top">
                    <span class="count-style">{{ singleThread.is_special_industry }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="许可证" placement="top"><span class="count-style">许可证</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.license" placement="top">
                    <span class="count-style">{{ singleThread.license }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="年营业额" placement="top"><span class="count-style">年营业额</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.custom_turnover" placement="top">
                    <span class="count-style">{{ singleThread.custom_turnover }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="员工数量" placement="top"><span class="count-style">员工数量</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.custom_staff" placement="top">
                    <span class="count-style">{{ singleThread.custom_staff }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="客户套餐需求" placement="top"><span class="count-style">客户套餐需求</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.need_combo" placement="top">
                    <span class="count-style">{{ singleThread.need_combo }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="客户来源" placement="top"><span class="count-style">客户来源</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.custom_source" placement="top">
                    <span class="count-style">{{ singleThread.custom_source }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="无需套餐原因" placement="top"><span class="count-style">无需套餐原因</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.not_need_cause" placement="top">
                    <span class="count-style">{{ singleThread.not_need_cause }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="可能需要服务" placement="top"><span class="count-style">可能需要服务</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.maybe_need_server" placement="top">
                    <span class="count-style">{{ singleThread.maybe_need_server }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="是否其他需求" placement="top"><span class="count-style">是否其他需求</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.is_orther_need" placement="top">
                    <span class="count-style">{{ singleThread.is_orther_need }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="咨询分类" placement="top"><span class="count-style">咨询分类</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.refer_cate" placement="top">
                    <span class="count-style">{{ singleThread.refer_cate }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="园区" placement="top"><span class="count-style">园区</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.garden" placement="top">
                    <span class="count-style">{{ singleThread.garden }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="群聊ID" placement="top"><span class="count-style">群聊ID</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.group_chat_id" placement="top">
                    <span class="count-style">{{ singleThread.group_chat_id }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="IM人员" placement="top"><span class="count-style">IM人员</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.im_name" placement="top">
                    <span class="count-style">{{ singleThread.im_name }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="是否添加微信" placement="top"><span class="count-style">是否添加微信</span></el-tooltip>
              </el-col>
              <el-col :span="7" class="m-td">
                <el-tooltip :content="singleThread.is_add_wx === 1 ? '否' : '是'" placement="top">
                    <span class="count-style">{{ singleThread.is_add_wx === 1 ? '否' : '是' }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="线索创建人" placement="top"><span class="count-style">线索创建人</span></el-tooltip>
              </el-col>
              <el-col :span="19" class="m-td">
                <el-tooltip :content="singleThread.im_id === '' ? '系统创建' : singleThread.im_name" placement="top">
                    <span class="count-style">{{ singleThread.im_id === '' ? '系统创建' : singleThread.im_name }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="咨询关键内容" placement="top"><span class="count-style">咨询关键内容</span></el-tooltip>
              </el-col>
              <el-col :span="19" class="m-td">
                <el-tooltip :content="singleThread.refer_content" placement="top">
                    <span class="count-style">{{ singleThread.refer_content }}</span>
                </el-tooltip>
              </el-col>
              <el-col :span="5" class="m-th">
                <el-tooltip content="备注" placement="top"><span class="count-style">备注</span></el-tooltip>
              </el-col>
              <el-col :span="19" class="m-td">
                <el-tooltip :content="singleThread.remark" placement="top">
                    <span class="count-style">{{ singleThread.remark }}</span>
                </el-tooltip>
              </el-col>
            </el-row>

        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
export default {
  name: 'ChatRecord',
  props: {
    threadId: Number
  },
  data () {
    return {
      activeName: 'first',
      activities: [],
      OperationRecord: [],
      // 是否显示回复框
      commentVisible: '',
      // 回复面板保存
      buttonVisible: '',
      // 回复文本域属性初始化
      textareaSize: { minRows: 4, maxRows: 2 },
      // 初始化回复内容
      addCommentData: {
        id: '',
        uid: '',
        communicat_content: ''
      },
      singleThread: {}
    }
  },
  watch: {
    threadId: function (val) {
      this.activities = []
      this.OperationRecord = []
      this.commentVisible = ''
      this.buttonVisible = ''
      if (val) this.getChatRecord(val)
      if (val) this.getThreadBasicInfo(val)
    }
  },
  computed: {
    maskedPhoneNumber() {
      return function(phoneNumber) {
        return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
      };
    }
  },
  methods: {
    getThreadBasicInfo (threadId) {
      // 获取一条线索基本信息
      this.$axios.get('api/thread/detail/' + threadId)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.singleThread = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    getChatRecord (threadId) {
      this.getOperationRecord(threadId)
      this.$axios.get('api/thread/communicatelist/' + threadId)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.handleForMethods(threadId, data.data)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    getOperationRecord (id) {
      this.$axios.get('/api/thread/operatelist/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            for (var a = 0; a < data.data.length; a++) {
              this.OperationRecord.push(data.data[a])
            }
          }
        })
    },
    handleForMethods (id, data) {
      this.activities = data
      for (var a = 0; a < this.activities.length; a++) {
        if (this.activities[a].communicat_type === 1) {
          this.activities[a].communicat_type = '通过 ' + this.getFeedBack(data[a].communicat_type) + '与客户沟通了' + data[a].call_duration + '秒'
        } else {
          this.activities[a].communicat_type = '通过 ' + this.getFeedBack(data[a].communicat_type) + '与客户进行了沟通'
        }
        if (data[a].communicat_img) {
          this.activities[a].preview = data[a].communicat_img.split(',')
        }
        this.activities[a].size = 'large'
        this.activities[a].type = 'primary'
        this.activities[a].icon = 'el-icon-s-custom'
      }
    },
    // 点击回复操作
    handleComment (activity, index) {
      this.commentVisible = index
      this.buttonVisible = index
    },
    // 保存回复操作
    handleCommentConfirm (activity, index) {
      if (!this.addCommentData.communicat_content) {
        this.$message.error('沟通内容不能为空')
        return
      }
      this.$axios.post('/api/thread/return_communicat/' + activity.communication_id,
        {
          uid: activity.uid,
          communicat_content: this.addCommentData.communicat_content
        })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.activities[index].son.push(data.data)
            this.handleCommentConfirmClose()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 关闭回复框  清空原始数据
    handleCommentConfirmClose () {
      this.addCommentData.communicat_content = ''
      this.addCommentData.uid = ''
      this.commentVisible = ''
      this.buttonVisible = ''
    },
    getFeedBack (key) {
      let vipData = [' ', '电话联系', '手机短信', '发送快递', '微信交流', '见面拜谈', '公司洽谈', '优开平台']
      return vipData[key]
    },
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }

}
</script>

<style lang="stylus" scoped>
.m-tab
  border-top: 1px solid #dee2e6
  border-left: 1px solid #dee2e6
.m-th
  height: 42px
  line-height: 42px
  padding: 0 5px
  border-bottom: 1px solid #dee2e6
  background: #fafafa;
.m-td
  height: 42px
  line-height: 42px
  padding: 0 5px
  border-left: 1px solid #dee2e6
  border-right: 1px solid #dee2e6
  border-bottom: 1px solid #dee2e6
.chat_record {
  font-size: 12px;
}
.m-tabs-content {
  overflow-y auto;
}
.block {
  height auto
  overflow-y auto
  padding-top .2rem
  padding-left .2rem
  box-sizing border-box
}
.time_right {
  width 100%
  margin-top .4rem
  overflow hidden
  word-break break-all
  white-space normal
}
.time_line {
  line-height .5rem
}
.handleLinkImg {
  margin-right 0.2rem
}
.handleLinkImg:nth-last-child(1) {
  margin-right 0
}
.m_comment {
  padding .2rem .4rem
  flex-direction column
  margin-bottom .2rem
  background #f3f3f3
  height auto
  border-radius .09rem
}
.public {
  display flex
  box-sizing border-box
  width 100%
}
.comment_name_time {
  margin-bottom .4rem
  display flex
  flex-direction row
  justify-content space-between
  line-height .5rem
}
.chatRecord >>> .el-tabs__content {
  overflow visible
}
</style>



// WEBPACK FOOTER //
// src/common/ChatRecord.vue